import { render, staticRenderFns } from "./ConsignacaoCancelar.vue?vue&type=template&id=276346f2&scoped=true&"
import script from "./ConsignacaoCancelar.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoCancelar.vue?vue&type=script&lang=js&"
import style0 from "./ConsignacaoCancelar.vue?vue&type=style&index=0&id=276346f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276346f2",
  null
  
)

export default component.exports